import type { PreviewDraft } from '@/features/editor/preview/LivePreview';
import type { PortfolioSectionKind } from '@/types/portfolio';

export const SAMPLE_DRAFT: PreviewDraft = {
  hero: {
    portraitUrl: '',
    tagline: 'Independent designer & engineer',
    headline: 'Quiet, considered software for curious teams.',
    subheadline:
      'I help small teams design and ship interfaces that feel calm, legible, and deliberate — one release at a time.',
    ctaLabel: 'Get in touch',
    ctaHref: 'mailto:hello@example.com',
    availability: 'available',
  },
  about: {
    body: 'Ten years of designing and building web software — most recently leading product design at an analytics startup. I care about typography, tight feedback loops, and teams that ship.',
    skills: ['Product design', 'TypeScript', 'React', 'Design systems', 'Prototyping'],
    resumeUrl: '',
  },
  projects: {
    items: [
      {
        id: 'p1',
        title: 'Cache layer rewrite',
        summary:
          'Rebuilt the query cache from the ground up — cut p95 dashboard load from 4.1s to 680ms.',
        role: 'Lead engineer',
        client: 'Acme Analytics',
        year: '2025',
        url: '',
        mediaKind: 'none',
        mediaUrl: '',
        mediaAlt: '',
        tags: ['Infrastructure', 'Performance'],
        bullets: [],
      },
      {
        id: 'p2',
        title: 'Edge router',
        summary:
          'A tiny, typed router for edge workers. Built to be read in an afternoon and extended in a week.',
        role: 'Maintainer',
        client: 'Open source',
        year: '2024',
        url: '',
        mediaKind: 'none',
        mediaUrl: '',
        mediaAlt: '',
        tags: ['Open source', 'TypeScript'],
        bullets: [],
      },
      {
        id: 'p3',
        title: 'Field notes',
        summary:
          'A writing practice on software, craft, and the slow work of making small correct things.',
        role: 'Writer',
        client: 'Personal',
        year: '2024',
        url: '',
        mediaKind: 'none',
        mediaUrl: '',
        mediaAlt: '',
        tags: ['Writing'],
        bullets: [],
      },
    ],
  },
  experience: {
    items: [
      {
        id: 'e1',
        company: 'Acme Analytics',
        role: 'Staff engineer',
        location: 'Remote',
        start: '2023',
        end: '',
        current: true,
        summary: 'Leading platform work on the query and caching layer.',
        highlights: [
          'Rewrote the cache layer — 6x faster dashboards',
          'Mentored four engineers into senior roles',
        ],
      },
      {
        id: 'e2',
        company: 'Foundry',
        role: 'Senior engineer',
        location: 'Brooklyn, NY',
        start: '2019',
        end: '2023',
        current: false,
        summary: 'Built design tooling for in-house product teams.',
        highlights: [],
      },
    ],
  },
  education: {
    items: [
      {
        id: 'ed1',
        institution: 'Rhode Island School of Design',
        credential: 'BFA, Graphic Design',
        startYear: '2012',
        endYear: '2016',
        gpa: '',
        note: 'Thesis: typography for dense interfaces.',
      },
    ],
  },
  contact: {
    email: 'hello@example.com',
    location: 'Brooklyn, NY',
    links: [
      { id: 'l1', platform: 'github', label: 'GitHub', href: 'https://github.com' },
      { id: 'l2', platform: 'linkedin', label: 'LinkedIn', href: 'https://linkedin.com' },
    ],
    allowInquiryForm: true,
  },
};

export const SAMPLE_ENABLED: ReadonlySet<PortfolioSectionKind> = new Set<PortfolioSectionKind>([
  'hero',
  'about',
  'projects',
  'experience',
  'education',
  'contact',
]);
